'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultAdEndedListener;

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

var _actions = require('../../store/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultAdEndedListener(state, next, playerId) {
  _store2.default.storeInstance().dispatch((0, _actions.setAdEnded)(playerId, true));
  _store2.default.storeInstance().dispatch((0, _actions.setAdBegan)(playerId, false));
}
module.exports = exports['default'];